import { render, staticRenderFns } from "./HomeV2.html?vue&type=template&id=54670786&scoped=true&"
import script from "./HomeV2.js?vue&type=script&lang=js&"
export * from "./HomeV2.js?vue&type=script&lang=js&"
import style0 from "./HomeV2.scss?vue&type=style&index=0&id=54670786&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54670786",
  null
  
)

export default component.exports